import styled from 'styled-components'

export const Container = styled.div`
	position: relative;
	flex-grow: 1;
	display: flex;
	flex-direction: column;
`
